import {Cog} from "@reviewpush/streamline-regular/lib/interface-essential/Settings";
import {ConversationChatText} from "@reviewpush/streamline-regular/lib/messages-chat-smileys/Conversation";
import {SendEmail} from "@reviewpush/streamline-regular/lib/emails/SendEmail";
import {PieLineGraph} from "@reviewpush/streamline-regular/lib/interface-essential/Dashboard";
import {PinLocation1} from "@reviewpush/streamline-regular/lib/maps-navigation/Pins";
import {HouseChimney2} from "@reviewpush/streamline-regular/lib/interface-essential/Home";
import {SignBadgeRectangularRound} from "@reviewpush/streamline-regular/lib/maps-navigation/SignShapes";

export default (iconName) => {
    switch(iconName){
    case 'home':
        return HouseChimney2;
    case 'locations':
        return PinLocation1;
    case 'measure':
        return PieLineGraph;
    case 'request':
        return SendEmail;
    case 'respond':
        return ConversationChatText;
    case 'settings':
        return Cog;
    default:
        return SignBadgeRectangularRound;
    }
};
